<template>
  <ACarousel
    ref="swiperTop"
    :options="swiperOptionTop"
    class="swiper"
  >
    <ACarouselSlide
      v-for="( item, key ) in list"
      :key="key"
      :index="key"
    >
      <AImage
        :img="item"
      />
      <span
        v-if="item && item.alt"
        class="carousel-caption"
      >
        <div class="group-description-wrapper">
          <div class="description-icon">
            <font-awesome-icon
              icon="camera"
              class="icon"
              fixed-width
            />
          </div>
          <div class="description">
            {{ item.alt }}
          </div>
        </div>
      </span>
    </ACarouselSlide>
  </ACarousel>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCamera } from '@fortawesome/free-solid-svg-icons'
library.add(faCamera)

export default {
  name: 'node-element-article-carousel',
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data: function() {
    return {
      collapsed: false,
      errors: [],
      items: [],
      host: '',
      background: [],
      swiperOptionTop: {
        loop: false,
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@scss/custom.scss";

.swiper-button-prev {
  margin-left:1rem;
  }
.swiper-button-next {
  margin-right:1rem;
}
.swiper-additional-info {
  flex-direction: row;
  display: flex;
  margin: 1em 0em;
}
.swiper-thumbs-control {
  color:$white;
  cursor:pointer;
}
.description-icon {
  margin-right:1em;
}
.group-description-wrapper {
    flex-direction: row;
    display: flex;
}
.event-gallery-pagination {
  color:$white;
  font-size:1em;
  width:auto;
  flex-grow: 1;
}
.swiper-slide .carousel-caption {
  bottom: 0;
  left: 0;
  padding: 3em 1.5em 1.5em 1.5em;
  color:$white;
  width:100%;
  text-align:left;
  background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 60%, transparent 100%);
  position:absolute;
  z-index:2;
}
.aspect-ratio-16by9 {
  @include responsive-ratio(16,9);
}

</style>
